/* eslint-disable @typescript-eslint/no-explicit-any */
import IconOpen from '@/sinister/header/components/common/IconOpen'
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { Dropdown } from 'antd'
import { FC } from 'react'
import Button from './Button'
import MenuDropdown from './MenuDropdown'
import Text from './Text'

interface DropdownGroupProps {
  items: any[]
  text: string
  className?: string
}

interface DropdownGroupLogicProps extends DropdownGroupProps {
  Wrapper: FC<any>
}

interface DropdownGroupLayoutProps {
  items: any[]
  text: string
  className?: string
  color: string
}

const DropdownGroupLogic: FC<DropdownGroupLogicProps> = ({
  Wrapper,
  items = [],
  text,
  className,
}) => {
  const { colorSubheader: color } = useHeaderContext()
  return (
    <Wrapper items={items} text={text} className={className} color={color} />
  )
}

const DropdownGroupLayout: FC<DropdownGroupLayoutProps> = ({
  items,
  text,
  className,
  color,
}) => (
  <Dropdown
    dropdownRender={() => <MenuDropdown items={items} />}
    trigger={['click']}
    placement="topRight"
    className={className}
    getPopupContainer={(triggerNode) =>
      triggerNode.parentElement || triggerNode
    }
  >
    <Button
      type={className as 'button' | 'submit' | 'reset'}
      color={color || 'var(--color-white)'}
    >
      <Text text={text} color={color} />
      <IconOpen />
    </Button>
  </Dropdown>
)

const DropdownGroup: FC<DropdownGroupProps> = ({ items, text, className }) => (
  <DropdownGroupLogic
    Wrapper={DropdownGroupLayout}
    items={items}
    text={text}
    className={className}
  />
)

export default DropdownGroup
